<template>
  <div
    class="FicheProjetA3__wrapper"
    style="position:absolute;width: 100%;height:100%;left:0;top:0;"
  >
    <page-inner :side="'left'" :large="true" v-if="format === 'A3'">
      <fiche
        class="fiche-container"
        style="display: flex; flex-direction: column"
      >
        <div
          style="display: flex; width: 100%; justify-self: flex-start; flex-wrap: wrap"
          class="pushes-gutter-down"
        >
          <div class="bigblock" style="display: block;">
            <haut-fiche :p="p" :pm="pm"></haut-fiche>
          </div>
          <div class="bigblock" style="display: block;">
            <haut-fiche-a3-droite :p="p" />
          </div>
          <div></div>
          <div class="bigblock" style="display: block; margin-right: 36mm;">
            <titre-fiche :p="p" :pm="pm"></titre-fiche>
          </div>
          <div class="bigblock" style="display: block;">
            <titre-fiche-a3-droite :pm="pm" :second-axe="secondAxe" />
          </div>
        </div>
        <div
          style="margin: auto; display: flex; width: 100%;"
          :style="{ height: `${availableHeight}px` }"
        >
          <div class="bigblock">
            <image-fiche
              :p="p"
              :pm="{ axe: 1, axe_image: pm.gen_image }"
            ></image-fiche>
          </div>
          <div class="bigblock">
            <image-fiche :p="p" :pm="pm"></image-fiche>
          </div>
        </div>
        <div style="justify-self: flex-end" class="pushes-gutter-up">
          <cartouche-fiche
            :p="p"
            :pm="pm"
            :drop="['missions', 'procedures']"
          ></cartouche-fiche>
        </div>
      </fiche>
    </page-inner>
  </div>
</template>
<script>
import {
  filterScalene,
  formatDate,
  formatNumbers,
  getDate,
  getEntrBySlug,
  getEntrNamesBySlugMatching,
  handleImageLoad,
  mapNames
} from "../../../../../util/func";

import CartoucheFiche from "../../../PrintComponents/Fiche/Projet/CartoucheFicheA3";
import Fiche from "../../../PrintComponents/Fiche/Fiche";
import HautFiche from "../../../PrintComponents/Fiche/Projet/HautFiche";
import ImageFiche from "../../../PrintComponents/Fiche/Projet/ImageFiche";
import PageInner from "../../../PrintComponents/Page/PageInner";
import TitreFiche from "../../../PrintComponents/Fiche/Projet/TitreFiche";
import HautFicheA3Droite from "./HautFicheA3Droite";
import TitreFicheA3Droite from "./TitreFicheA3Droite";

export default {
  name: "FichePaysage",
  components: {
    TitreFicheA3Droite,
    HautFicheA3Droite,
    TitreFiche,
    CartoucheFiche,
    Fiche,
    HautFiche,
    ImageFiche,
    PageInner
  },
  data() {
    return {
      availableHeight: 100
    };
  },
  computed: {
    architectes() {
      return getEntrNamesBySlugMatching("architecte", this.p.interlocuteurs_d);
    },
    secondAxe() {
      const c = this.p.contents_d.find(a => a.axe_id === this.pm.axe);
      return c ? c : false;
    }
  },
  props: {
    format: {},
    index: {},
    p: {},
    pm: {}
  },
  methods: {
    mapNames,
    getDate,
    formatDate,
    formatNumbers,
    filterScalene,
    handleImageLoad,
    getEntrBySlug,
    getEntrNamesBySlugMatching,
    secondPic(image) {
      const b = this.secondAxe;
      return b
        ? b.pictures.find(
            p => p && p.picture && p.picture.id === this.pm.axe_images[image]
          )
        : null;
    },
    async resetDimensions() {
      this.availableHeight = 0;
      await new Promise(r => this.$nextTick(r));
      const fullHeight = this.$el
        .querySelector(".fiche-container")
        .getBoundingClientRect().height;
      const topHeight = this.$el
        .querySelector(".pushes-gutter-down")
        .getBoundingClientRect().height;
      const bottomHeight = this.$el
        .querySelector(".pushes-gutter-up")
        .getBoundingClientRect().height;
      this.availableHeight = fullHeight - topHeight - bottomHeight;
      await new Promise(r => this.$nextTick(r));
    }
  },
  mounted() {
    this.resetDimensions();
  },
  watch: {
    pm: {
      handler() {
        this.resetDimensions();
      },
      deep: true
    }
  }
};
</script>
